import { ChannelDataObject } from "./ChannelDataObject";

export class ChannelMessage extends ChannelDataObject {
    readonly channelDataType: string = "Message";
    message: string;

    constructor(message: string) {
        super();
        this.message = message;
    }
}
